/**
 * The single source of truth for how large a case-list page may be.
 *
 * These mirror the server's `CaseListLimits` (Common/Constants/CaseListLimits.cs), which
 * in turn mirrors CMS's own clamp. Keeping the numbers in one module the SPA imports —
 * rather than a second hand-copied set — is the systemic fix PORT-PARITY calls for: the
 * control the SPA caps and the range the server coerces to are the same quantity, so the
 * two sides cannot silently diverge.
 *
 * The client cap is a courtesy that saves a round trip; the server clamp is the
 * authority. `clampPageSize` (utils/validation.ts) coerces to this range exactly as the
 * server's `Math.Clamp` does — an out-of-range value is bounded, never rejected.
 */
export const PAGE_SIZE_LIMITS = {
  /** The page size used when the caller names none. Matches the server default. */
  DEFAULT: 25,

  /** The smallest page a request may ask for; a non-positive size is coerced up to this. */
  MIN: 1,

  /** The largest page the portal will ask for; a larger request is coerced down to this. */
  MAX: 100,
} as const;
